import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Plugins from './plugins'
import Components from '@/components'
import './assets/animate.css';
import './assets/style.less'
import '@vant/touch-emulator';
import scroll from 'vue-seamless-scroll'
import filterpop from './filterpop'
import VueClipboard from 'vue-clipboard2'

if (process.env.NODE_ENV === 'development') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line no-new
  new VConsole()
}
Vue.prototype.$filterPop = filterpop
Vue.use(Plugins)
Vue.use(Components)
Vue.use(scroll)
Vue.use(VueClipboard)

Vue.config.productionTip = false

// 定义全局点击函数
Vue.prototype.globalClick = function (callback) {
  document.getElementById('app').onclick = function () {
    callback();
  };
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
